<template>
    <div v-auto-animate>
        <div
            @click="
                showDetails = !showDetails;
                fetchBatchDetails();
            "
            class="flex cursor-pointer select-none justify-between px-2 py-2 text-gray-700 sm:px-4 sm:py-3"
        >
            <div class="flex items-center">
                <base-stacked-cards-icon class="h-5 w-5" />
                <span class="ml-2 text-sm">Order batch</span>
            </div>
            <base-chevron-icon
                class="-ml-1 -mr-1 h-4 w-4 sm:ml-2"
                :class="{ 'rotate-180': showDetails }"
            />
        </div>
        <div
            class="px-2 pb-2 pl-10 text-sm text-gray-700 sm:px-4 sm:pb-3"
            v-if="showDetails"
            :class="{ spinner: isLoading }"
        >
            <span
                >This order was combined with
                {{ batchDetails.length - 1 }} other orders</span
            >
            <ul>
                <li v-for="order in filteredBatchDetails" :key="order.id">
                    <router-link
                        :to="buildContextAwareRoute(order.id)"
                        class="underline"
                        >#{{ order.code }}</router-link
                    >
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OrderBatchDetails',
    props: {
        orderId: {
            type: String,
            required: true
        },
        batchId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            showDetails: false,
            batchDetails: [],
            isLoading: false
        };
    },
    methods: {
        async fetchBatchDetails() {
            try {
                this.isLoading = true;

                const { data } = await this.$axios.get(
                    `/orders/batches/${this.batchId}/private`
                );
                this.batchDetails = data;
            } catch (error) {
                throw Error(error);
            } finally {
                this.isLoading = false;
            }
        },
        buildContextAwareRoute(orderId) {
            if (this.$route.path.includes('/live-orders/')) {
                return {
                    name: 'liveOrders',
                    params: { id: orderId }
                };
            }

            return {
                name: 'orderDetail',
                params: { id: orderId }
            };
        }
    },
    computed: {
        filteredBatchDetails() {
            return this.batchDetails.filter(order => order.id !== this.orderId);
        }
    }
};
</script>
